import {Observable, Subscription} from 'rxjs';

import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToEnded = (
    ended$: Observable<void>,
    playbackStore: IPlaybackStore
): Subscription =>
    ended$
        .subscribe(() => playbackStore.actions.end());

export default subscribeToEnded;